import { type FC, type ReactNode } from "react"

import { cn } from "@forento/shared-client/utilities/tailwind"

type Props = {
	headers: (string | { label: string; alignment?: "left" | "center" })[]
	data: { id: string | number; columns: ReactNode[] }[]
}

const Table: FC<Props> = ({ headers, data }) => (
	<div className="overflow-x-auto">
		<table className="w-full">
			<thead>
				<tr>
					{headers.map((header, index) => (
						<th
							key={index}
							className={cn(
								"p-4 text-sm font-normal text-light",
								index > 0 && "border-l border-[#e5e5e5]",
							)}
						>
							{typeof header === "string" ? header : header.label}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{data.map((row, rowIndex) => (
					<tr key={row.id} className={cn(rowIndex % 2 === 0 && "bg-[#f5f8f9]")}>
						{row.columns.map((cell, cellIndex) => {
							const headerCell = headers[cellIndex]
							const alignment = typeof headerCell !== "string" ? headerCell.alignment : undefined
							return (
								<td
									key={cellIndex}
									className={cn(
										"p-4",
										cellIndex > 0 && "border-l border-[#e5e5e5]",
										alignment === "center" && "text-center",
									)}
								>
									{cell}
								</td>
							)
						})}
					</tr>
				))}
			</tbody>
		</table>
	</div>
)

export default Table
